import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-144">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 w-full p-4 bg-brand-black/90 backdrop-blur-lg border-t border-white/10 z-50 md:hidden" data-id="element-145">
          <button onClick={scrollToPricing} className="w-full py-3 px-4 bg-brand-pink text-brand-black font-bold rounded-full shadow-[0_0_20px_rgba(248,200,220,0.3)] flex items-center justify-center gap-2" data-id="element-146">
            Quiero el Megapack — $19.990
          </button>
        </motion.div>}
    </AnimatePresence>;
}